import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SectionLabel } from "./SectionLabel";

export default function EliteHero() {
  return (
    <section className="relative py-28 md:py-36 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0D1F17] via-[#132A20] to-[#0D1F17]" />
      <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E\")" }} />
      <div className="absolute top-20 left-10 w-72 h-72 rounded-full bg-[#D4AF37]/5 blur-[100px]" />
      <div className="absolute bottom-10 right-10 w-96 h-96 rounded-full bg-[#A8D5BA]/5 blur-[120px]" />
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <SectionLabel light>Precision Fertility Program</SectionLabel>
          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight mt-6 mb-8" data-testid="elite-hero-title">
            Fitly <span className="italic font-light text-[#D4AF37]">Elite</span>
          </h1>
          <p className="text-[#F7F5F0]/60 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
            Precision fertility biohacking — online, structured, result-oriented.
          </p>
          <p className="text-[#A3B8AD]/60 text-sm max-w-xl mx-auto mt-3">
            A clinically guided nutrition method built around your body's own cycle — not internet guesswork.
          </p>
        </motion.div>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }} className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="#pricing" className="inline-flex items-center gap-2 bg-[#D4AF37] text-[#0D1F17] px-10 py-4 text-sm font-bold tracking-wide rounded-full hover:bg-[#B5952F] transition-all shadow-lg shadow-[#D4AF37]/20" data-testid="hero-enroll-cta">
            View Plans & Enroll <ArrowRight size={16} />
          </a>
          <a href="#method" className="inline-flex items-center gap-2 border border-[#F7F5F0]/15 text-[#F7F5F0]/70 px-8 py-4 text-sm tracking-wide rounded-full hover:border-[#D4AF37]/40 hover:text-[#F7F5F0] transition-all">
            Explore The Method
          </a>
        </motion.div>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.7 }}
          className="mt-16 flex flex-wrap items-center justify-center gap-8 md:gap-14">
          {[
            { value: "10,000+", label: "Clients Served" },
            { value: "98%", label: "Success Rate" },
            { value: "4.9", label: "Google Rating" },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-serif text-2xl md:text-3xl text-[#D4AF37]">{s.value}</p>
              <p className="text-xs text-[#A3B8AD]/60 mt-1 tracking-wider uppercase">{s.label}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
